import { useConfig } from "../../../contexts/useConfig";
import { useTranslation } from 'react-i18next';


import BuyIcon from "../../../assets/icons/buy.png";
import ActionButtonStandard from "../Action/ActionButtonStandard";
import {getPropertyOrDefault} from "../../../helpers/helpers";


export default function BuyButton() {
   const [config] = useConfig();
   const {t} = useTranslation();
   const showActionIcons = getPropertyOrDefault(config["show-action-icons"], true);
   


   return config.actions.buy && 
   <ActionButtonStandard 
   label={config?.customActionNames?.buy ?? t('buyButtonName')} 
   className={showActionIcons ? "" : "noIcons"}
   iconImg={BuyIcon} />;
}
